(function () {

    const nonnzEl = document.querySelector(".nonnz")
    const maincontentEl = document.querySelector(".main-content")
    if (maincontentEl && nonnzEl && Intl) {
        const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        console.log("timezone", userTimeZone, userTimeZone == "Pacific/Auckland")
        if (userTimeZone != "Pacific/Auckland") {
            maincontentEl.remove() //classList.add("hide")
            nonnzEl.classList.add("show")
        } else {
            nonnzEl.remove()
        }
    }
    // Curator code must be after removal of either non or nz content
    // to target the right element
    const curator = document.querySelector(".curator-feed-visit-kapiti-layout")
    if (curator) {
        curator.setAttribute("id", "curator-feed-visit-kapiti-layout");
        const src = curator.dataset.src
        if (src) {
            const script = document.createElement("script")
            script.async = 1
            script.src = src
            const scriptEls = document.getElementsByTagName("script");
            if (scriptEls.length > 0) {
                firstScriptEl = scriptEls[0]
                firstScriptEl.parentNode.insertBefore(script, firstScriptEl)
            }
        }
    }
})()